(function($) {
    'use strict';

    // Admin part of the plugin
    // Initialize the admin functionality when document is ready
    $(document).ready(function() {

        $('.wcps-copy-shortcode').on('click', function() {
            var shortcodeText = $(this).data('clipboard-text');
            
            // Use Clipboard API for modern browsers
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(shortcodeText)
                    .then(function() {
                        // Success feedback
                        var originalText = $(this).text();
                        $(this).text('Copied!');
                        
                        var $button = $(this);
                        setTimeout(function() {
                            $button.text(originalText);
                        }, 1500);
                    }.bind(this))
                    .catch(function() {
                        // Fallback to old method if clipboard API fails
                        fallbackCopyTextToClipboard(shortcodeText, $(this));
                    }.bind(this));
            } else {
                // Fallback for browsers that don't support clipboard API
                fallbackCopyTextToClipboard(shortcodeText, $(this));
            }
        });
        
         // Add clear search functionality
        $('#showcase-search-input').on('search', function() {
            if ($(this).val() === '') {
                // If search input is cleared, redirect to the page without search parameter
                window.location.href = removeURLParameter(window.location.href, 's');
            }
        });

        // Make sure checkboxes in header/footer sync with each other
        $('#cb-select-all-1, #cb-select-all-2').on('change', function() {
            var isChecked = $(this).prop('checked');
            $('#cb-select-all-1, #cb-select-all-2').prop('checked', isChecked);
            $('input[name="showcase_ids[]"]').prop('checked', isChecked);
        });

        // Handle checkbox changes to show/hide floating delete button
        $('input[name="showcase_ids[]"]').on('change', function() {
            var checkedCount = $('input[name="showcase_ids[]"]:checked').length;
            if (checkedCount > 0) {
                $('#wcps-floating-delete').fadeIn();
            } else {
                $('#wcps-floating-delete').fadeOut();
            }
        });

        // Handle "Select All" checkbox changes
        $('#cb-select-all-1, #cb-select-all-2').on('change', function() {
            var isChecked = $(this).prop('checked');
            if (isChecked) {
                $('#wcps-floating-delete').fadeIn();
            } else {
                $('#wcps-floating-delete').fadeOut();
            }
        });

        // Handle floating delete button click
        $('.wcps-bulk-delete').on('click', function() {
            var selectedIds = [];
            
            // Get all checked checkboxes
            $('input[name="showcase_ids[]"]:checked').each(function() {
                selectedIds.push($(this).val());
            });
            
            if (selectedIds.length === 0) {
                alert('Please select at least one showcase to delete.');
                return;
            }
            
            if (confirm('Are you sure you want to delete the selected showcases?')) {
                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'proddisp_bulk_delete_showcases',
                        ids: selectedIds,
                        nonce: $('#proddisp_nonce').val()
                    },
                    success: function(response) {
                        if (response.success) {
                            location.reload();
                        } else {
                            alert(response.data || 'An error occurred during the delete operation.');
                        }
                    },
                    error: function() {
                        alert('An error occurred during the delete operation.');
                    }
                });
            }
        });

        // Bulk action form handling
        $('#wcps-bulk-action-form').on('submit', function(e) {
            e.preventDefault();
            
            var action = $('#bulk-action-selector-top').val();
            if (action == '-1') {
                action = $('#bulk-action-selector-bottom').val();
            }
            
            if (action == 'delete') {
                var selectedIds = [];
                
                // Get all checked checkboxes with the name 'showcase_ids[]'
                $('input[name="showcase_ids[]"]:checked').each(function() {
                    selectedIds.push($(this).val());
                });
                
                if (selectedIds.length === 0) {
                    alert('Please select at least one showcase to delete.');
                    return;
                }
                
                if (confirm('Are you sure you want to delete the selected showcases?')) {
                    $.ajax({
                        url: ajaxurl,
                        type: 'POST',
                        data: {
                            action: 'proddisp_bulk_delete_showcases',
                            ids: selectedIds,
                            nonce:$('#proddisp_nonce').val()
                        },
                        success: function(response) {
                            if (response.success) {
                                location.reload();
                            } else {
                                alert(response.data || 'An error occurred during the delete operation.');
                            }
                        },
                        error: function() {
                            alert('An error occurred during the delete operation.');
                        }
                    });
                }
            }
        });



        // Delete showcase functionality
        $('.wcps-delete-showcase').on('click', function(e) {
            e.preventDefault();
            
            var showcaseId = $(this).data('id');
            
            if (confirm('Are you sure you want to delete this showcase? This action cannot be undone.')) {
                deleteShowcase(showcaseId);
            }
        });
        
        // Initialize color pickers in display 
        if ($.fn.wpColorPicker) {
            $('.wcps-color-picker').wpColorPicker({
                change: function(event, ui) {
                    // Get the input element
                    var $input = $(this);
                    // Update the input value with the new color
                    $input.val(ui.color.toString());
                    // Trigger the updatePreviewStyles function
                    updatePreviewStyles();
                }
            });
        }

        // Initialize select2 for product and category selectors

        if ($.fn.select2) {
            $('#proddisp_products, #proddisp_category, #proddisp_tag, #proddisp_brand, #proddisp_attribute, #proddisp_attribute_terms').select2({
                width: '100%',
                placeholder: 'Select items'
            });
        }

        // Tabs functionality
        $('.wcps-tabs-nav a').on('click', function(e) {
            e.preventDefault();
            
            // Remove active class from all tabs
            $('.wcps-tabs-nav a').removeClass('active');
            $('.wcps-tab-panel').removeClass('active');
            
            // Add active class to current tab
            $(this).addClass('active');
            
            // Show the corresponding panel
            $($(this).attr('href')).addClass('active');
            
            // Save active tab to localStorage
            var activeTab = $(this).attr('href');
            localStorage.setItem('proddisp_active_tab', activeTab);
        });

        // Initialize tabs on page load to prevent jumping
        $(document).ready(function() {
            // Hide all tabs and panels initially
            $('.wcps-tabs-nav a').removeClass('active');
            $('.wcps-tab-panel').removeClass('active');
            
            var savedTab = localStorage.getItem('proddisp_active_tab');
            
            if (savedTab) {
                // Check if the saved tab exists
                var $savedTabLink = $('.wcps-tabs-nav a[href="' + savedTab + '"]');
                if ($savedTabLink.length > 0) {
                    // Add active class to saved tab
                    $savedTabLink.addClass('active');
                    $(savedTab).addClass('active');
                } else {
                    // If saved tab doesn't exist, default to first tab
                    $('.wcps-tabs-nav a:first').addClass('active');
                    $('.wcps-tab-panel:first').addClass('active');
                }
            } else {
                // If no saved tab, default to first tab
                $('.wcps-tabs-nav a:first').addClass('active');
                $('.wcps-tab-panel:first').addClass('active');
            }

            // Initialize copy functionality
            initCopyFunctionality();
        });

        // Initialize copy functionality
        function initCopyFunctionality() {
            console.log('Initializing copy functionality...');
            
            // Shortcode copy functionality
            $(document).on('click', '.wcps-copy-shortcode-btn', function(e) {
                e.preventDefault();
                console.log('Copy button clicked');
                
                var shortcode = $(this).data('shortcode');
                var $button = $(this);
                
                console.log('Shortcode to copy:', shortcode);
                
                // Copy to clipboard
                if (navigator.clipboard && window.isSecureContext) {
                    // Use modern clipboard API
                    navigator.clipboard.writeText(shortcode).then(function() {
                        console.log('Copied successfully via clipboard API');
                        showCopySuccess($button);
                    }).catch(function(err) {
                        console.log('Clipboard API failed:', err);
                        fallbackCopyTextToClipboard(shortcode, $button);
                    });
                } else {
                    // Fallback for older browsers
                    console.log('Using fallback copy method');
                    fallbackCopyTextToClipboard(shortcode, $button);
                }
            });
        }

        // Toggle fields based on product and cat source selection
        $('input[name="proddisp_product_source"]').on('change', function() {
            var source = $(this).val();

            if (source === 'specific') {
                $('#wcps-specific-products').show();
                $('#wcps-category-selection, #wcps-tag-selection, #wcps-brand-selection, #wcps-attribute-selection').hide();
            } else if (source === 'category') {
                $('#wcps-category-selection').show();
                $('#wcps-specific-products, #wcps-tag-selection, #wcps-brand-selection, #wcps-attribute-selection').hide();
            } else if (source === 'tag') {
                $('#wcps-tag-selection').show();
                $('#wcps-specific-products, #wcps-category-selection, #wcps-brand-selection, #wcps-attribute-selection').hide();
            } else if (source === 'brand') {
                $('#wcps-brand-selection').show();
                $('#wcps-specific-products, #wcps-category-selection, #wcps-tag-selection, #wcps-attribute-selection').hide();
            } else if (source === 'attribute') {
                $('#wcps-attribute-selection').show();
                $('#wcps-specific-products, #wcps-category-selection, #wcps-tag-selection, #wcps-brand-selection').hide();
            }

            
            // Update preview
            generatePreview();
        });

        // Toggle excerpt length field based on show description checkbox
        $('input[name="proddisp_show_description"]').on('change', function() {
            if ($(this).is(':checked')) {
                $('#wcps-excerpt-length').show();
            } else {
                $('#wcps-excerpt-length').hide();
            }
            
            // Update preview
            generatePreview();
        });


        // Handle attribute selection change to load terms dynamically 
        $('#proddisp_attribute').on('change', function() {
            var selectedAttribute = $(this).val();
            var $termsSelect = $('#proddisp_attribute_terms');
            var $termsContainer = $('#wcps-attribute-terms');
            
            if (selectedAttribute) {
                // Show the terms container
                $termsContainer.show();
                
                // Clear existing options and add loading indicator
                $termsSelect.html('<option value="">Loading terms...</option>');
                
                // Destroy select2 before making changes
                if ($.fn.select2 && $termsSelect.hasClass('select2-hidden-accessible')) {
                    $termsSelect.select2('destroy');
                }
                
                // Make AJAX request to get terms for the selected attribute
                $.ajax({
                    url: ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'proddisp_get_attribute_terms',
                        attribute: selectedAttribute,
                        nonce: $('#proddisp_nonce').val()
                    },
                    success: function(response) {
                        if (response.success && response.data.terms) {
                            // Clear the select and add new options
                            $termsSelect.empty();
                            
                            // Add each term as an option
                            $.each(response.data.terms, function(index, term) {
                                $termsSelect.append('<option value="' + term.term_id + '">' + term.name + '</option>');
                            });
                            
                            // Reinitialize select2
                            if ($.fn.select2) {
                                $termsSelect.select2({
                                    width: '100%',
                                    placeholder: 'Select terms'
                                });
                            }
                        } else {
                            $termsSelect.html('<option value="">No terms found</option>');
                            
                            // Still reinitialize select2 even with no terms
                            if ($.fn.select2) {
                                $termsSelect.select2({
                                    width: '100%',
                                    placeholder: 'No terms available'
                                });
                            }
                        }
                    },
                    error: function() {
                        $termsSelect.html('<option value="">Error loading terms</option>');
                        
                        // Reinitialize select2 on error
                        if ($.fn.select2) {
                            $termsSelect.select2({
                                width: '100%',
                                placeholder: 'Error loading terms'
                            });
                        }
                    }
                });
            } else {
                // Hide and clear the terms container if no attribute is selected
                $termsContainer.hide();
                
                // Destroy select2 before clearing
                if ($.fn.select2 && $termsSelect.hasClass('select2-hidden-accessible')) {
                    $termsSelect.select2('destroy');
                }
                
                $termsSelect.empty();
            }
            
            // Update preview after attribute change
            generatePreview();
        });
        

        // Hide and show the editor 
        $('.wcps-toggle-settings').on('click', function() {
            $('.wcps-settings-column').toggleClass('collapsed');
            $('.wcps-preview-column').toggleClass('expanded');
            
            // Update toggle button text
            var $toggleText = $(this).find('.toggle-text');
            if ($toggleText.text() === 'Hide Settings') {
                $toggleText.text('Show Settings');
            } else {
                $toggleText.text('Hide Settings');
            }
        });

        // Make settings panel sticky on scroll
        if ($(window).width() > 1200) {
            var adminBar = $('#wpadminbar').height();
            var previewColumn = $('.wcps-preview-column');
            var previewColumnTop = previewColumn.offset() ? previewColumn.offset().top - adminBar : 0;
            
            $(window).on('scroll', function() {
                var scrollTop = $(window).scrollTop();
                
                if (scrollTop > previewColumnTop && previewColumnTop > 0) {
                    previewColumn.addClass('wcps-sticky-preview');
                    previewColumn.css('top', (adminBar + 20) + 'px');
                } else {
                    previewColumn.removeClass('wcps-sticky-preview');
                    previewColumn.css('top', '0');
                }
            });
        }

    
        // Add real-time preview functionality collapsed and open 
        $('.wcps-settings-subheading').on('click', function() {
            var $content = $(this).next('.form-table');
            $content.slideToggle(300);
            $(this).toggleClass('collapsed');
            
            // Save state to localStorage
            var sectionId = $(this).text().trim().replace(/\s+/g, '-').toLowerCase();
            localStorage.setItem('proddisp_section_' + sectionId, $(this).hasClass('collapsed') ? 'closed' : 'open');
        });
        
        // Restore collapse state from localStorage
        $('.wcps-settings-subheading').each(function() {
            var sectionId = $(this).text().trim().replace(/\s+/g, '-').toLowerCase();
            var state = localStorage.getItem('proddisp_section_' + sectionId);
            
            if (state === 'closed') {
                $(this).addClass('collapsed');
                $(this).next('.form-table').hide();
            }
        });

        // Toggle slider specific settings based on layout selection  Layout Type
        $('#proddisp_layout').on('change', function() {
            var layout = $(this).val();
            
            // Hide all layout-specific settings
            $('.wcps-layout-specific').hide();
            
            // Show settings for the selected layout
            $('.' + layout + '-specific').show();
        
            // Update style options based on the selected layout
            updateStyleOptions(layout);
            
            // Update preview
            generatePreview();
        });
        // END ------------------------
        // =============================================Functions =============================================

        // Function to remove URL parameter on search in admin showcase list page 
        function removeURLParameter(url, parameter) {
            var urlParts = url.split('?');
            if (urlParts.length >= 2) {
                var prefix = encodeURIComponent(parameter) + '=';
                var parts = urlParts[1].split(/[&;]/g);

                for (var i = parts.length; i-- > 0;) {
                    if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                        parts.splice(i, 1);
                    }
                }
                
                return urlParts[0] + (parts.length > 0 ? '?' + parts.join('&') : '');
            }
            return url;
        }


            // Define style options for each layout type
        var layoutStyles = {
            // Layout add 08
            'grid': [
                {value: 'basic-grid', label: 'Basic Grid Style 1'},
                {value: 'basic-grid-2', label: 'Basic Grid Style 2'},
                {value: 'basic-grid-3', label: 'Basic Grid Style 3'}
            ],
            'cta': [
                {value: 'cta-layout', label: 'Call to Action (CTA) 1'},
                {value: 'cta-layout-2', label: 'Call to Action (CTA) 2'},
                {value: 'cta-layout-3', label: 'Call to Action (CTA) 3'}
            ],
            'list': [
                {value: 'list-layout', label: 'Product List 3 Column'},
                {value: 'list-layout-2', label: 'Product List Modern Card'},
                {value: 'list-layout-3', label: 'Product List Minimalist'}
            ],
            'card_grid': [
                {value: 'card-grid', label: 'Card Grid Style 1'},
                {value: 'card-grid-2', label: 'Card Grid Style 2'},
                {value: 'card-grid-3', label: 'Card Grid Style 3'}
            ],
            'flip': [
                {value: 'flip-layout', label: 'Square Flip Box'},
                {value: 'flip-layout-2', label: 'Vertical Flip Box'},
                {value: 'flip-layout-3', label: 'Diagonal Flip Box'},
                {value: 'flip-layout-4', label: 'Book Page Flip'},
                {value: 'flip-layout-5', label: 'Morphing Blob Flip'}
            ],
            'masonry_grid': [
                {value: 'masonry-grid', label: 'Masonry Grid Style 1'},
                {value: 'masonry-grid-2', label: 'Masonry Grid Style 2'},
                {value: 'masonry-grid-3', label: 'Masonry Grid Style 3'}
            ],
            'gallery': [
                {value: 'gallery', label: 'Gallery Style 1'},
                {value: 'gallery-2', label: 'Gallery Style 2'},
                {value: 'gallery-3', label: 'Gallery Style 3'}
            ],
            'showcase': [
                {value: 'showcase', label: 'Featured Showcase Style 1'},
                {value: 'showcase-2', label: 'Featured Showcase Style 2'},
                {value: 'showcase-3', label: 'Featured Showcase Style 3'}
            ],
            'slider': [
                {value: 'slider', label: 'Basic Slider Style 1'},
                {value: 'slider-2', label: 'Basic Slider Style 2'},
                {value: 'slider-3', label: 'Basic Slider Style 3'}
            ],
            'table': [
                {value: 'table', label: 'Basic Table Style 1'},
                {value: 'table-2', label: 'Basic Table Style 2'},
                {value: 'table-3', label: 'Basic Table Style 3'}
            ],
            'category_tabs': [
                {value: 'category_tabs', label: 'Horizontal Tabs Style 1'},
                {value: 'category_tabs_2', label: 'Horizontal Tabs Style 2'},
                {value: 'category_tabs_3', label: 'Horizontal Tabs Style 3'}
            ],
        };



        // Function to update style options based on selected layout
        function updateStyleOptions(layout) {
            var $styleSelect = $('#proddisp_layout_mode');
            var currentStyle = $styleSelect.val();
            
            // Clear existing showcase sub laymode mode 
            $styleSelect.empty();
            
            // Add new options based on selected layout
            if (layoutStyles[layout]) {
                $.each(layoutStyles[layout], function(index, style) {
                    var selected = (currentStyle === style.value) ? ' selected' : '';
                    $styleSelect.append('<option value="' + style.value + '"' + selected + '>' + style.label + '</option>');
                });
            } else {
                // Fallback default options if no specific styles defined
                $styleSelect.append('<option value="basic-grid">Basic Grid</option>');
                $styleSelect.append('<option value="card-grid">Card Grid</option>');
                $styleSelect.append('<option value="masonry-grid">Masonry Grid</option>');
            }
            
            // Update preview after style options change
            generatePreview();
        }


        // Update the current layout when back to editor page to update layout style 
        $(document).ready(function() {
            var initialLayout = $('#proddisp_layout').val();
            updateStyleOptions(initialLayout);
        });

         // Refresh preview button
        $('.wcps-refresh-preview').on('click', function() {
            generatePreview();
        });

        // Generate preview on any form change
        $('#wcps-showcase-form input, #wcps-showcase-form select').on('change', function() {
            generatePreview();
            // Auto-save on field change (only if we have a showcase ID - editing mode)
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                autoSaveShowcase();
            }
        });

        // Additional event listeners for different input types
        $('#wcps-showcase-form input[type="checkbox"], #wcps-showcase-form input[type="radio"]').on('change', function() {
            generatePreview();
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                autoSaveShowcase();
            }
        });

        // Handle Select2 changes if Select2 is used
        $(document).on('select2:select select2:unselect select2:clear', '#wcps-showcase-form select', function() {
            generatePreview();
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                autoSaveShowcase();
            }
        });

        // Handle any dynamic content changes
        $(document).on('change', '#wcps-showcase-form select, #wcps-showcase-form input[type="checkbox"], #wcps-showcase-form input[type="radio"]', function() {
            generatePreview();
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                autoSaveShowcase();
            }
        });

        // Comprehensive event listener for all form field changes
        $(document).on('change input', '#wcps-showcase-form input, #wcps-showcase-form select, #wcps-showcase-form textarea', function(e) {
            // Skip input events for text fields (they use debounced auto-save)
            if (e.type === 'input' && $(this).is('input[type="text"], input[type="number"], textarea')) {
                return;
            }
            
            generatePreview();
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                autoSaveShowcase();
            }
        });

        // Debug logging to check if events are firing
        $(document).on('change', '#wcps-showcase-form input, #wcps-showcase-form select', function() {
            console.log('Form field changed:', $(this).attr('name'), $(this).val());
        });

        // Specific event listener for checkbox fields
        $(document).on('change', '#wcps-showcase-form input[type="checkbox"]', function() {
            console.log('Checkbox changed:', $(this).attr('name'), $(this).is(':checked'));
            generatePreview();
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                console.log('Triggering auto-save for checkbox change');
                autoSaveShowcase();
            }
        });

        // Specific event listener for select fields
        $(document).on('change', '#wcps-showcase-form select', function() {
            console.log('Select changed:', $(this).attr('name'), $(this).val());
            generatePreview();
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                console.log('Triggering auto-save for select change');
                autoSaveShowcase();
            }
        });

        // Auto-save on input events for real-time saving
        $('#wcps-showcase-form input[type="text"], #wcps-showcase-form input[type="number"], #wcps-showcase-form textarea').on('input', function() {
            // Debounce auto-save to avoid too many requests
            clearTimeout(window.autoSaveTimeout);
            var showcaseId = $('input[name="showcase_id"]').val();
            if (showcaseId) {
                window.autoSaveTimeout = setTimeout(function() {
                    autoSaveShowcase();
                }, 1000); // Save after 1 second of no typing
            }
        });

        // Initial preview generation
        generatePreview();

        // Initialize button text
        if ($('.wcps-save-showcase').length) {
            var showcaseId = $('input[name="showcase_id"]').val();
            var buttonText = showcaseId ? 'Update Showcase' : 'Save Showcase';
            $('.wcps-save-showcase').text(buttonText);
            window.originalButtonText = buttonText;
        }

        // Form submission
        $('#wcps-showcase-form').on('submit', function(e) {
            e.preventDefault();
            saveShowcase();
        });

        // Prevent form submission on Enter key press in input fields---------------------------------------
        $('#wcps-showcase-form input[type="text"], #wcps-showcase-form input[type="number"], #wcps-showcase-form input[type="email"], #wcps-showcase-form input[type="url"], #wcps-showcase-form input[type="search"], #wcps-showcase-form textarea').on('keydown', function(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });

        // Prevent form submission on Enter key press in select fields
        $('#wcps-showcase-form select').on('keydown', function(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                e.preventDefault();
                return false;
            }
        });

        // END ----------------------------------------------------

        // Layout mode change event class name 
        $('#proddisp_layout_mode').on('change', function() {
            // Update the container class immediately (in case AJAX is slow)
            setTimeout(updatePreviewContainerClass, 100);
            
            // Also update after AJAX completes
            $(document).ajaxComplete(function(event, xhr, settings) {
                // Check if this is the preview AJAX request
                if (settings.data && typeof settings.data === 'string' && settings.data.indexOf('action=proddisp_get_shortcode_preview') !== -1) {
                    // Update the container class after preview is loaded
                    setTimeout(updatePreviewContainerClass, 200);
                }
            });
        });

        // Product search filter for specific products
        $(document).on('input', '#wcps-product-search', function() {
            var search = $(this).val().toLowerCase();
            $('#proddisp_products option').each(function() {
                var text = $(this).text().toLowerCase();
                $(this).toggle(text.indexOf(search) !== -1);
            });
            // If using Select2, trigger change for live update
            if ($.fn.select2 && $('#proddisp_products').data('select2')) {
                $('#proddisp_products').trigger('change.select2');
            }
        });
        

        // Reusable function to show the ToastMaster pricing modal
        function showPricingModal() {
            Toast.price({
                title: '🚀 Your Ultimate WooCommerce Companion!',
                subtitle: 'Evaluate the features and select a bundle based on your needs.',
                toggles: {
                  options: ['Yearly', 'Lifetime'],
                  active: 'Yearly',
                  savings: { 'Yearly': 'Save 73%', 'Lifetime': 'Save 80%' }
                },
                plans: [
                  {
                    name: 'Single',
                    prices: {
                      'Yearly': { original: 155.88, current: 41.99, period: '/year' },
                      'Lifetime': { original: 155.88, current: 108.49, period: '/lifetime' }
                    },
                    features: [
                        'All Pro Layout Showcase', 
                        'Editor page Easy Layout Type and Mode Selections',
                        'Display Mode Product Actions',
                        'Upcomming Showcase',
                        'Priority Support',
                    ],
                    button: {
                      text: 'Get It Now',
                      callback: function(data) { 
                            // data contains: { plan, toggle, prices }
                            pricingCallback(data.plan, data.toggle); 
                        }
                    }
                  },
                  {
                    name: 'Pro-5',
                    prices: {
                   
                      'Yearly': { original: 359.88, current: 120.99, period: '/year' },
                      'Lifetime': { original: 426.75, current: 240.99, period: '/lifetime' }
                    },
                   features: [
                        'All Pro Layout Showcase', 
                        'Editor page Easy Layout Type and Mode Selections',
                        'Display Mode Product Actions',
                        'Upcomming Showcase',
                        'Priority Support',
                    ],
                    button: {
                      text: 'Grab It Now',
                      callback: function(data) { 
                            // data contains: { plan, toggle, prices }
                            pricingCallback(data.plan, data.toggle); 
                        }
                    },
                     tag: Toast.tag('new', 'HOT DEAL', '#e74c3c')
                  },
                  {
                    name: 'Agency-100',
                    prices: {
                      'Yearly': { original: 599.88, current: 320.99, period: '/year' },
                      'Lifetime': { original: 751.00, current: 448.99, period: '/lifetime' }
                    },
                   features: [
                        'All Pro Layout Showcase', 
                        'Editor page Easy Layout Type and Mode Selections',
                        'Display Mode Product Actions',
                        'Upcomming Showcase',
                        'Priority Support',
                    ],
                    button: {
                      text: 'Get It Now',
                      callback: function(data) { 
                            // data contains: { plan, toggle, prices }
                            pricingCallback(data.plan, data.toggle); 
                        }
                    },
                   
                  }
                ],
                recommended: 'Pro',
                guarantee: { 
                  days: 14, 
                  title: '14-Day Money-Back Guarantee', 
                  text: 'Try it risk-free. If you\'re not satisfied, get a full refund within 14 days.' 
                },
                backdropClose: true,
                bodyClose: true,
                escClose: true
              });
        }
        // Make the entire .wcps-pro-locked area clickable for the ToastMaster pricing modal
        $(document).on('click', '.wcps-pro-locked', function(e) {
            showPricingModal();
        });
        // Add click handler for .wcps-upgrade-pro-btn to show the same pricing modal
        $(document).on('click', '.wcps-upgrade-pro-btn', function(e) {
            e.preventDefault();
            showPricingModal();
        });
        // Prevent modal on input click inside .wcps-pro-locked
        $(document).on('click', '.wcps-pro-locked input, .wcps-pro-locked select, .wcps-pro-locked textarea, .wcps-pro-locked label', function(e) {
            e.stopPropagation();
        });

    });

    // Pricing Function 
    function pricingCallback(plan, selectedToggle) {

        let licenses = 1; // Default for Single
        if (plan.name === 'Single') {
            licenses = 1;
        } else if (plan.name === 'Pro-5') {
            licenses = 5;
        }
        else if (plan.name === 'Agency-100') {
            licenses = 100;
        }
        
        // Determine billing cycle based on selected toggle
        let billingCycle = 'yearly'; // Default
        if (selectedToggle === 'Lifetime') {
            billingCycle = 'lifetime';
        }
        
        console.log('Selected Plan:', plan.name);
        console.log('Selected Toggle:', selectedToggle);
        console.log('Licenses:', licenses);
        console.log('Billing Cycle:', billingCycle);
       
        const handler = FS.Checkout.configure({
            plugin_id: '19582',
            plan_id: '32465',
            public_key: 'pk_5e7406cb0a5b592c68a76ad7b706c',
        });

        handler.open({
            name: 'Product Display',
            licenses: licenses,
            billing_cycle: billingCycle,
            purchaseCompleted: function (response) {
                // The logic here will be executed immediately after the purchase confirmation.
                // alert(response.user.email);
            },
            success: function (response) {
                // The logic here will be executed after the customer closes the checkout, after a successful purchase.
                // alert(response.user.email);
            }
        });
    }

    // Add to the existing generatePreview function
    var originalGeneratePreview = window.generatePreview || function() {};
    window.generatePreview = function() {
        // Call the original function
        originalGeneratePreview.apply(this, arguments);
        
        // Update the container class after the preview is generated
        setTimeout(updatePreviewContainerClass, 500);
    };

    // Also update on initial load
    setTimeout(updatePreviewContainerClass, 1000);

    
    // ENd 

    function updatePreviewContainerClass() {
        // Get the selected layout mode
        var selectedLayoutMode = $('#proddisp_layout_mode').val();
        
        // Target the preview container and update its class
        var $previewContainer = $('#wcps-showcase-preview .wcps-container');
        
        if ($previewContainer.length) {
            // Remove any existing layout classes (that start with wcps-layout-)
            var classesToRemove = [];
            $.each($previewContainer.attr('class').split(' '), function(index, className) {
                if (className.indexOf('wcps-layout-') === 0) {
                    classesToRemove.push(className);
                }
            });
            
            $previewContainer.removeClass(classesToRemove.join(' '));
            
            // Add the new layout class based on the selected layout mode
            $previewContainer.addClass('wcps-layout-' + selectedLayoutMode);
            
            console.log('Updated container class to: wcps-layout-' + selectedLayoutMode);
        } else {
            console.log('Preview container not found');
        }
    }

    // END 

    function fallbackCopyTextToClipboard(text, $button) {
        var tempInput = $('<input>');
        $('body').append(tempInput);
        tempInput.val(text).select();
        
        try {
            var successful = document.execCommand('copy');
            
            if (successful) {
                console.log('Copied successfully via fallback method');
                showCopySuccess($button);
            } else {
                console.error('Fallback copy failed');
                alert('Failed to copy to clipboard. Please try selecting and copying the text manually.');
            }
        } catch (err) {
            console.error('Unable to copy to clipboard', err);
            alert('Failed to copy to clipboard. Please try selecting and copying the text manually.');
        }
        
        tempInput.remove();
    }


    /**
     * Generate preview based on current form values
     */
   
    function generatePreview() {
        // Show loading indicator
        $('#wcps-showcase-preview').html('<div class="wcps-loading"></div>');
        
         // Get the current layout value explicitly
        var currentLayout = $('#proddisp_layout').val();

        // Prepare form data for AJAX
        var formData = {
            action: 'proddisp_get_shortcode_preview',
            nonce: $('#proddisp_nonce').val(),
            data: {proddisp_layout: currentLayout}
        };

        // Add showcase_id to preview data
        formData.data['id'] = $('input[name="showcase_id"]').val();

        console.log(formData)
        
        // Get basic form fields
        $('#wcps-showcase-form').find('input, select, textarea').each(function() {
            var input = $(this);
            var name = input.attr('name');
            
            // Skip buttons, submit inputs, and elements without a name
            if (!name || input.attr('type') === 'submit' || input.attr('type') === 'button') {
                return;
            }
            
            // Handle checkboxes
            if (input.attr('type') === 'checkbox') {
                formData.data[name] = input.is(':checked') ? input.val() : '';
            }
            // Handle radio buttons
            else if (input.attr('type') === 'radio') {
                if (input.is(':checked')) {
                    formData.data[name] = input.val();
                }
            }
            // Special handling for product and category selects
            else if (name === 'proddisp_products[]') {
                formData.data['product_ids'] = input.val();
            }
            else if (name === 'proddisp_category[]') {
                formData.data['category_ids'] = input.val();
            }
            else if (name === 'proddisp_tag[]') {
                formData.data['proddisp_tag'] = input.val();
            }
            else if (name === 'proddisp_brand[]') {
                formData.data['categoryproddisp_brand_ids'] = input.val();
            }
            else if (name === 'proddisp_attribute[]') {
                formData.data['proddisp_attribute'] = input.val();
            }
            else if (name === 'proddisp_attribute_terms[]') {
                formData.data['attribute_terms'] = input.val();
            }
            
            // Handle all other inputs
            else {
                formData.data[name] = input.val();
            }
        });
        

        // AJAX request to get preview
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            success: function(response) {
                if (response.success) {
                    $('#wcps-showcase-preview').html(response.data.html);

                    // Update the layout class after HTML is loaded
                    var currentLayoutMode = $('#proddisp_layout_mode').val();
                    var layoutClass = 'wcps-layout-' + currentLayoutMode;
                    
                    $('#wcps-showcase-preview .wcps-container').removeClass(function(index, className) {
                        return (className.match(/(^|\s)wcps-layout-\S+/g) || []).join(' ');
                    }).addClass(layoutClass);
                    
                } else {
                    $('#wcps-showcase-preview').html('<div class="notice notice-error"><p>' + response.data + '</p></div>');
                }
            },
            error: function() {
                $('#wcps-showcase-preview').html('<div class="notice notice-error"><p>Error generating preview. Please try again.</p></div>');
            }
        });
    }


    /**
     * Clear all messages
     */
    function clearAllMessages() {
        $('.wcps-auto-save-message').remove();
        $('.wcps-form-actions .notice').remove();
    }

    /**
     * Auto-save showcase via AJAX (no page reload)
     */
    function autoSaveShowcase() {
        console.log('autoSaveShowcase called');
        
        // Don't auto-save if we don't have a showcase ID (new showcase)
        var showcaseId = $('input[name="showcase_id"]').val();
        if (!showcaseId) {
            console.log('No showcase ID, skipping auto-save');
            return;
        }

        // Don't auto-save if manual save is in progress
        if ($('.wcps-save-showcase').prop('disabled')) {
            console.log('Manual save in progress, skipping auto-save');
            return;
        }

        // Prevent multiple auto-save calls
        if (window.autoSaveInProgress) {
            console.log('Auto-save already in progress, skipping');
            return;
        }
        window.autoSaveInProgress = true;
        console.log('Starting auto-save for showcase ID:', showcaseId);

        // Store original button text only once (if not already stored)
        if (!window.originalButtonText) {
            window.originalButtonText = $('.wcps-save-showcase').text();
        }

        // Show auto-saving indicator
        var $saveButton = $('.wcps-save-showcase');
        $saveButton.prop('disabled', true).text('Auto-saving...');
        
        // Prepare form data (same as saveShowcase but without page reload)
        var formData = new FormData();
        formData.append('action', 'proddisp_save_shortcode');
        formData.append('nonce', $('#proddisp_nonce').val());
        formData.append('id', showcaseId);
        
        // Add all form fields (same as saveShowcase)
        formData.append('name', $('#proddisp_name').val());
        formData.append('layout', $('#proddisp_layout').val());
        formData.append('proddisp_layout_mode', $('#proddisp_layout_mode').val());
        formData.append('product_source', $('input[name="proddisp_product_source"]:checked').val());
        
        // Handle multi-select values correctly
        var products = $('#proddisp_products').val();
        if (products && products.length) {
            for (var i = 0; i < products.length; i++) {
                formData.append('products[]', products[i]);
            }
        }
        
        var categories = $('#proddisp_category').val();
        if (categories && categories.length) {
            for (var i = 0; i < categories.length; i++) {
                formData.append('category[]', categories[i]);
            }
        }

        // Handle tags
        var tags = $('#proddisp_tag').val();
        if (tags && tags.length) {
            for (var i = 0; i < tags.length; i++) {
                formData.append('tag[]', tags[i]);
            }
        }

        // Handle brands
        var brands = $('#proddisp_brand').val();
        if (brands && brands.length) {
            for (var i = 0; i < brands.length; i++) {
                formData.append('brand[]', brands[i]);
            }
        }

        // Handle attributes
        var attribute = $('#proddisp_attribute').val();
        if (attribute) {
            formData.append('attribute', attribute);
            
            var attributeTerms = $('#proddisp_attribute_terms').val();
            if (attributeTerms && attributeTerms.length) {
                for (var i = 0; i < attributeTerms.length; i++) {
                    formData.append('attribute_terms[]', attributeTerms[i]);
                }
            }
        }
        
        // Add all other fields (same as saveShowcase)
        formData.append('limit', $('#proddisp_limit').val());
        formData.append('columns', $('#proddisp_columns').val());
        formData.append('orderby', $('#proddisp_orderby').val());
        formData.append('order', $('#proddisp_order').val());
        formData.append('image_size', $('#proddisp_image_size').val());
        
        // Add checkbox fields
        formData.append('show_title', $('#wcps-showcase-form input[name="proddisp_show_title"]').is(':checked') ? 'yes' : '');
        formData.append('show_price', $('#wcps-showcase-form input[name="proddisp_show_price"]').is(':checked') ? 'yes' : '');
        formData.append('show_rating', $('#wcps-showcase-form input[name="proddisp_show_rating"]').is(':checked') ? 'yes' : '');
        formData.append('show_description', $('#wcps-showcase-form input[name="proddisp_show_description"]').is(':checked') ? 'yes' : '');
        formData.append('excerpt_length', $('#proddisp_excerpt_length').val());
        
        // Slider specific fields
        formData.append('autoplay', $('#wcps-showcase-form input[name="proddisp_autoplay"]').is(':checked') ? 'yes' : '');
        formData.append('arrows', $('#wcps-showcase-form input[name="proddisp_arrows"]').is(':checked') ? 'yes' : '');
        formData.append('dots', $('#wcps-showcase-form input[name="proddisp_dots"]').is(':checked') ? 'yes' : '');
        formData.append('slide_speed', $('#proddisp_slide_speed').val());
        
        // Design fields
        formData.append('product_title', $('#proddisp_product_title').val());
        formData.append('price_delete_color', $('#proddisp_delete_color').val());
        formData.append('background', $('#proddisp_background').val());
        formData.append('product_content_padding', $('#proddisp_product_content_padding').val());
        formData.append('border_radius', $('#proddisp_border_radius').val());
        formData.append('padding', $('#proddisp_padding').val());
        formData.append('description_color', $('#proddisp_description_color').val());
        formData.append('price_color', $('#proddisp_price_color').val());
        formData.append('star_color', $('#proddisp_star_color').val());

        // New all fields added here 
        formData.append('container_background', $('#proddisp_container_background').val() || '#ffffff3b');
        formData.append('container_padding', $('#proddisp_container_padding').val() || '25px');
        formData.append('container_margin', $('#proddisp_container_margin').val() || '0');
        formData.append('grid_gap', $('#proddisp_grid_gap').val() || '20px');
        formData.append('grid_width', $('#proddisp_grid_width').val() || '100%');
        formData.append('product_width', $('#proddisp_product_width').val() || '100%');
        formData.append('product_flex', $('#proddisp_product_flex').val() || '0 0 auto');
        formData.append('product_background', $('#proddisp_product_background').val() || '#ffffff');
        formData.append('product_image_width', $('#proddisp_product_image_width').val() || '100%');
        formData.append('product_image_height', $('#proddisp_product_image_height').val() || 'auto');
        formData.append('product_badge_font_size', $('#proddisp_product_badge_font_size').val() || '12px');
        formData.append('product_badge_font_weight', $('#proddisp_product_badge_font_weight').val() || 'normal');
        formData.append('product_badge_text_transform', $('#proddisp_product_badge_text_transform').val() || 'none');
        formData.append('product_badge_border_radius', $('#proddisp_product_badge_border_radius').val() || '0');
        formData.append('product_badge_padding', $('#proddisp_product_badge_padding').val() || '5px 10px');
        formData.append('product_badge_background', $('#proddisp_product_badge_background').val() || '#000000');
        formData.append('product_badge_font_color', $('#proddisp_product_badge_font_color').val() || '#ffffff');
        formData.append('product_badge_text_align', $('#proddisp_product_badge_text_align').val() || 'center');
        formData.append('product_badge_margin', $('#proddisp_product_badge_margin').val() || '0');
        formData.append('product_badge_position', $('#proddisp_product_badge_position').val() || 'absolute');
        formData.append('product_badge_top', $('#proddisp_product_badge_top').val() || '10px');
        formData.append('product_badge_right', $('#proddisp_product_badge_right').val() || '10px');
        formData.append('product_badge_left', $('#proddisp_product_badge_left').val() || 'auto');
        formData.append('product_badge_z_index', $('#proddisp_product_badge_z_index').val() || '1');
        formData.append('product_actions_position_left', $('#proddisp_product_actions_position_left').val() || '50%');
        formData.append('product_actions_gap', $('#proddisp_product_actions_gap').val() || '10px');
        formData.append('product_actions_padding', $('#proddisp_product_actions_padding').val() || '10px');
        formData.append('product_actions_direction', $('#proddisp_product_actions_direction').val() || 'row');
        formData.append('product_actions_text_align', $('#proddisp_product_actions_text_align').val() || 'center');
        formData.append('product_actions_outer_width', $('#proddisp_product_actions_outer_width').val() || '100%');
        formData.append('button_font_size', $('#proddisp_button_font_size').val() || '14px');
        formData.append('button_inside_width', $('#proddisp_button_inside_width').val() || '100%');
        formData.append('button_padding', $('#proddisp_button_padding').val() || '10px 20px');
        formData.append('button_margin', $('#proddisp_button_margin').val() || '0');
        formData.append('button_border', $('#proddisp_button_border').val() || 'none');
        formData.append('button_hover_border', $('#proddisp_button_hover_border').val() || 'none');
        formData.append('product_content_margin', $('#proddisp_product_content_margin').val() || '0');
        formData.append('product_content_direction', $('#proddisp_product_content_direction').val() || 'column');
        formData.append('product_content_background', $('#proddisp_product_content_background').val() || 'transparent');
        formData.append('product_title_hover_color', $('#proddisp_product_title_hover_color').val() || '#0170B9');
        formData.append('star_size', $('#proddisp_star_size').val() || '14px');
        formData.append('box_shadow', $('#proddisp_box_shadow').val());
        formData.append('border_style', $('#proddisp_border_style').val());
        formData.append('border_width', $('#proddisp_border_width').val());
        formData.append('border_color', $('#proddisp_border_color').val());
        formData.append('image_aspect_ratio', $('#proddisp_image_aspect_ratio').val());
        formData.append('image_hover_effect', $('#proddisp_image_hover_effect').val());
        formData.append('image_border_radius', $('#proddisp_image_border_radius').val());
        formData.append('title_size', $('#proddisp_title_size').val());
        formData.append('title_weight', $('#proddisp_title_weight').val());
        formData.append('price_size', $('#proddisp_price_size').val());
        formData.append('price_weight', $('#proddisp_price_weight').val());
        formData.append('desc_size', $('#proddisp_desc_size').val());
        formData.append('text_align', $('#proddisp_text_align').val());
        formData.append('button_style', $('#proddisp_button_style').val());
        formData.append('button_border_radius', $('#proddisp_button_border_radius').val());
        formData.append('button_bg_color', $('#proddisp_button_bg_color').val());
        formData.append('button_text_color', $('#proddisp_button_text_color').val());
        formData.append('button_hover_bg', $('#proddisp_button_hover_bg').val());
        formData.append('button_hover_text_color', $('#proddisp_button_hover_text_color').val());
        formData.append('button_animation', $('#proddisp_button_animation').val());
        formData.append('hover_effect', $('#proddisp_hover_effect').val());
        formData.append('hover_transition', $('#proddisp_hover_transition').val());
        formData.append('show_compare', $('#wcps-showcase-form input[name="proddisp_show_compare"]').is(':checked') ? 'yes' : '');
        formData.append('show_wishlist', $('#wcps-showcase-form input[name="proddisp_show_wishlist"]').is(':checked') ? 'yes' : '');
        formData.append('show_quickview', $('#wcps-showcase-form input[name="proddisp_show_quickview"]').is(':checked') ? 'yes' : '');
        formData.append('show_addtocart', $('#wcps-showcase-form input[name="proddisp_show_addtocart"]').is(':checked') ? 'yes' : '');
        formData.append('compare_display_mode', $('select[name="proddisp_compare_display_mode"]').val());
        formData.append('wishlist_display_mode', $('select[name="proddisp_wishlist_display_mode"]').val());
        formData.append('quickview_display_mode', $('select[name="proddisp_quickview_display_mode"]').val());
        formData.append('addtocart_display_mode', $('select[name="proddisp_addtocart_display_mode"]').val());
        formData.append('compare_icon', $('input[name="proddisp_compare_icon"]').val());
        formData.append('wishlist_icon', $('input[name="proddisp_wishlist_icon"]').val());
        formData.append('quickview_icon', $('input[name="proddisp_quickview_icon"]').val());
        formData.append('addtocart_icon', $('input[name="proddisp_addtocart_icon"]').val());
        formData.append('action_position', $('#proddisp_action_position').val());
        formData.append('enable_ajax', $('#wcps-showcase-form input[name="proddisp_enable_ajax"]').is(':checked') ? 'yes' : '');
        formData.append('enable_filters', $('#wcps-showcase-form input[name="proddisp_enable_filters"]').is(':checked') ? 'yes' : '');
        formData.append('enable_pagination', $('#wcps-showcase-form input[name="proddisp_enable_pagination"]').is(':checked') ? 'yes' : '');
        
        // AJAX request to auto-save showcase
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.success) {
                    // Show auto-save success message (auto-dismiss after 2 seconds)
                    showAutoSaveMessage('Changes saved automatically', 'success');
                } else {
                    // Show auto-save error message
                    showAutoSaveMessage('Auto-save failed: ' + response.data, 'error');
                }
                // Reset button and auto-save flag
                $saveButton.prop('disabled', false).text(window.originalButtonText);
                window.autoSaveInProgress = false;
            },
            error: function() {
                // Show auto-save error message
                showAutoSaveMessage('Auto-save failed. Please try again.', 'error');
                $saveButton.prop('disabled', false).text(window.originalButtonText);
                window.autoSaveInProgress = false;
            }
        });
    }

    /**
     * Show auto-save message (auto-dismiss after 2 seconds)
     */
    function showAutoSaveMessage(message, type) {
        // Remove any existing auto-save messages and regular notices
        $('.wcps-auto-save-message').remove();
        $('.wcps-form-actions .notice').remove();
        
        // Create message element with unique ID
        var messageClass = type === 'success' ? 'notice-success' : 'notice-error';
        var messageId = 'wcps-msg-' + Date.now();
        var $message = $('<div id="' + messageId + '" class="wcps-auto-save-message notice ' + messageClass + ' is-dismissible"><p>' + message + '</p></div>');
        
        // Add to form actions area
        $('.wcps-form-actions').prepend($message);
        
        // Auto-dismiss after 2 seconds with more robust removal
        setTimeout(function() {
            $('#' + messageId).fadeOut(300, function() {
                $(this).remove();
            });
        }, 2000);
        
        // Also add a backup removal after 3 seconds to ensure cleanup
        setTimeout(function() {
            $('#' + messageId).remove();
        }, 3000);
    }

    /**
     * Save showcase via AJAX
     */
    function saveShowcase() {
        // Clear any existing auto-save messages first
        clearAllMessages();
        
        // Show saving indicator
        $('.wcps-save-showcase').prop('disabled', true).text('Saving...');
        
        // Prepare form data
        var formData = new FormData();
        formData.append('action', 'proddisp_save_shortcode');
        formData.append('nonce', $('#proddisp_nonce').val());
        
        // Get showcase ID if editing
        var showcaseId = $('input[name="showcase_id"]').val();
        if (showcaseId) {
            formData.append('id', showcaseId);
        }
        
        // Add all form fields
        formData.append('name', $('#proddisp_name').val());
        formData.append('layout', $('#proddisp_layout').val());
        formData.append('proddisp_layout_mode', $('#proddisp_layout_mode').val());
        formData.append('product_source', $('input[name="proddisp_product_source"]:checked').val());
        
        // Handle multi-select values correctly
        var products = $('#proddisp_products').val();
        if (products && products.length) {
            // Use the same name format as what PHP expects
            for (var i = 0; i < products.length; i++) {
                formData.append('products[]', products[i]);
            }
        }
        
        var categories = $('#proddisp_category').val();
        if (categories && categories.length) {
            // Use the same name format as what PHP expects
            for (var i = 0; i < categories.length; i++) {
                formData.append('category[]', categories[i]);
            }
        }

        // Handle tags - ADDED
        var tags = $('#proddisp_tag').val();
        if (tags && tags.length) {
            for (var i = 0; i < tags.length; i++) {
                formData.append('tag[]', tags[i]);
            }
        }

        // Handle brands - ADDED
        var brands = $('#proddisp_brand').val();
        if (brands && brands.length) {
            for (var i = 0; i < brands.length; i++) {
                formData.append('brand[]', brands[i]);
            }
        }

        // Handle attributes - ADDED
       var attribute = $('#proddisp_attribute').val();
        if (attribute) {
            formData.append('attribute', attribute);
            
            // Handle attribute terms - FIXED field name
            var attributeTerms = $('#proddisp_attribute_terms').val();
            if (attributeTerms && attributeTerms.length) {
                for (var i = 0; i < attributeTerms.length; i++) {
                    formData.append('attribute_terms[]', attributeTerms[i]);
                }
            }
        }
        

        // Save 8
        // Add numeric fields
        formData.append('limit', $('#proddisp_limit').val());
        formData.append('columns', $('#proddisp_columns').val());
        formData.append('orderby', $('#proddisp_orderby').val());
        formData.append('order', $('#proddisp_order').val());
        formData.append('image_size', $('#proddisp_image_size').val());
        
        // Add checkbox fields - use consistent value format ('yes' or '')
        formData.append('show_title', $('#wcps-showcase-form input[name="proddisp_show_title"]').is(':checked') ? 'yes' : '');
        formData.append('show_price', $('#wcps-showcase-form input[name="proddisp_show_price"]').is(':checked') ? 'yes' : '');
        formData.append('show_rating', $('#wcps-showcase-form input[name="proddisp_show_rating"]').is(':checked') ? 'yes' : '');
        formData.append('show_description', $('#wcps-showcase-form input[name="proddisp_show_description"]').is(':checked') ? 'yes' : '');
        formData.append('excerpt_length', $('#proddisp_excerpt_length').val());
        
        // Slider specific fields
        formData.append('autoplay', $('#wcps-showcase-form input[name="proddisp_autoplay"]').is(':checked') ? 'yes' : '');
        formData.append('arrows', $('#wcps-showcase-form input[name="proddisp_arrows"]').is(':checked') ? 'yes' : '');
        formData.append('dots', $('#wcps-showcase-form input[name="proddisp_dots"]').is(':checked') ? 'yes' : '');
        formData.append('slide_speed', $('#proddisp_slide_speed').val());
        
        // Design fields
        formData.append('product_title', $('#proddisp_product_title').val());
        formData.append('price_delete_color', $('#proddisp_delete_color').val());
        formData.append('background', $('#proddisp_background').val());
        formData.append('product_content_padding', $('#proddisp_product_content_padding').val());
        formData.append('border_radius', $('#proddisp_border_radius').val());
        formData.append('padding', $('#proddisp_padding').val());

        formData.append('description_color', $('#proddisp_description_color').val());
        formData.append('price_color', $('#proddisp_price_color').val());
        formData.append('star_color', $('#proddisp_star_color').val());

        // New all fields added here 
        formData.append('container_background', $('#proddisp_container_background').val() || '#ffffff3b');
        formData.append('container_padding', $('#proddisp_container_padding').val() || '25px');
        formData.append('container_margin', $('#proddisp_container_margin').val() || '0');
        formData.append('grid_gap', $('#proddisp_grid_gap').val() || '20px');
        formData.append('grid_width', $('#proddisp_grid_width').val() || '100%');
        formData.append('product_width', $('#proddisp_product_width').val() || '100%');
        formData.append('product_flex', $('#proddisp_product_flex').val() || '0 0 auto');
        formData.append('product_background', $('#proddisp_product_background').val() || '#ffffff');

        formData.append('product_image_width', $('#proddisp_product_image_width').val() || '100%');
        formData.append('product_image_height', $('#proddisp_product_image_height').val() || 'auto');
        formData.append('product_badge_font_size', $('#proddisp_product_badge_font_size').val() || '12px');
        formData.append('product_badge_font_weight', $('#proddisp_product_badge_font_weight').val() || 'normal');
        formData.append('product_badge_text_transform', $('#proddisp_product_badge_text_transform').val() || 'none');
        formData.append('product_badge_border_radius', $('#proddisp_product_badge_border_radius').val() || '0');
        formData.append('product_badge_padding', $('#proddisp_product_badge_padding').val() || '5px 10px');
        formData.append('product_badge_background', $('#proddisp_product_badge_background').val() || '#000000');
        formData.append('product_badge_font_color', $('#proddisp_product_badge_font_color').val() || '#ffffff');
        formData.append('product_badge_text_align', $('#proddisp_product_badge_text_align').val() || 'center');
        formData.append('product_badge_margin', $('#proddisp_product_badge_margin').val() || '0');
        formData.append('product_badge_position', $('#proddisp_product_badge_position').val() || 'absolute');
        formData.append('product_badge_top', $('#proddisp_product_badge_top').val() || '10px');
        formData.append('product_badge_right', $('#proddisp_product_badge_right').val() || '10px');
        formData.append('product_badge_left', $('#proddisp_product_badge_left').val() || 'auto');
        formData.append('product_badge_z_index', $('#proddisp_product_badge_z_index').val() || '1');

        formData.append('product_actions_position_left', $('#proddisp_product_actions_position_left').val() || '50%');
        formData.append('product_actions_gap', $('#proddisp_product_actions_gap').val() || '10px');
        formData.append('product_actions_padding', $('#proddisp_product_actions_padding').val() || '10px');
        formData.append('product_actions_direction', $('#proddisp_product_actions_direction').val() || 'row');
        formData.append('product_actions_text_align', $('#proddisp_product_actions_text_align').val() || 'center');
        formData.append('product_actions_outer_width', $('#proddisp_product_actions_outer_width').val() || '100%');

        formData.append('button_font_size', $('#proddisp_button_font_size').val() || '14px');
        formData.append('button_inside_width', $('#proddisp_button_inside_width').val() || '100%');
        formData.append('button_padding', $('#proddisp_button_padding').val() || '10px 20px');
        formData.append('button_margin', $('#proddisp_button_margin').val() || '0');
        formData.append('button_border', $('#proddisp_button_border').val() || 'none');
        formData.append('button_hover_border', $('#proddisp_button_hover_border').val() || 'none');
        formData.append('product_content_margin', $('#proddisp_product_content_margin').val() || '0');
        formData.append('product_content_direction', $('#proddisp_product_content_direction').val() || 'column');
        formData.append('product_content_background', $('#proddisp_product_content_background').val() || 'transparent');
        formData.append('product_title_hover_color', $('#proddisp_product_title_hover_color').val() || '#0170B9');
        formData.append('star_size', $('#proddisp_star_size').val() || '14px');

        // Product Card Style
        formData.append('box_shadow', $('#proddisp_box_shadow').val());
        formData.append('border_style', $('#proddisp_border_style').val());
        formData.append('border_width', $('#proddisp_border_width').val());
        formData.append('border_color', $('#proddisp_border_color').val());

        // Image Settings
        formData.append('image_aspect_ratio', $('#proddisp_image_aspect_ratio').val());
        formData.append('image_hover_effect', $('#proddisp_image_hover_effect').val());
        formData.append('image_border_radius', $('#proddisp_image_border_radius').val());

        // Typography Settings
        formData.append('title_size', $('#proddisp_title_size').val());
        formData.append('title_weight', $('#proddisp_title_weight').val());
        formData.append('price_size', $('#proddisp_price_size').val());
        formData.append('price_weight', $('#proddisp_price_weight').val());
        formData.append('desc_size', $('#proddisp_desc_size').val());
        formData.append('text_align', $('#proddisp_text_align').val());

        // Button Settings
        formData.append('button_style', $('#proddisp_button_style').val());
        formData.append('button_border_radius', $('#proddisp_button_border_radius').val());
        formData.append('button_bg_color', $('#proddisp_button_bg_color').val());
        formData.append('button_text_color', $('#proddisp_button_text_color').val());
        formData.append('button_hover_bg', $('#proddisp_button_hover_bg').val());
        formData.append('button_hover_text_color', $('#proddisp_button_hover_text_color').val());
        formData.append('button_animation', $('#proddisp_button_animation').val());

        // Hover Effects
        formData.append('hover_effect', $('#proddisp_hover_effect').val());
        formData.append('hover_transition', $('#proddisp_hover_transition').val());

        // Features fields
        formData.append('show_compare', $('#wcps-showcase-form input[name="proddisp_show_compare"]').is(':checked') ? 'yes' : '');
        formData.append('show_wishlist', $('#wcps-showcase-form input[name="proddisp_show_wishlist"]').is(':checked') ? 'yes' : '');
        formData.append('show_quickview', $('#wcps-showcase-form input[name="proddisp_show_quickview"]').is(':checked') ? 'yes' : '');
        formData.append('show_addtocart', $('#wcps-showcase-form input[name="proddisp_show_addtocart"]').is(':checked') ? 'yes' : '');

    
        formData.append('compare_display_mode', $('select[name="proddisp_compare_display_mode"]').val());
        formData.append('wishlist_display_mode', $('select[name="proddisp_wishlist_display_mode"]').val());
        formData.append('quickview_display_mode', $('select[name="proddisp_quickview_display_mode"]').val());
        formData.append('addtocart_display_mode', $('select[name="proddisp_addtocart_display_mode"]').val());

       
        formData.append('compare_icon', $('input[name="proddisp_compare_icon"]').val());
        formData.append('wishlist_icon', $('input[name="proddisp_wishlist_icon"]').val());
        formData.append('quickview_icon', $('input[name="proddisp_quickview_icon"]').val());
        formData.append('addtocart_icon', $('input[name="proddisp_addtocart_icon"]').val());


        formData.append('action_position', $('#proddisp_action_position').val());
        formData.append('enable_ajax', $('#wcps-showcase-form input[name="proddisp_enable_ajax"]').is(':checked') ? 'yes' : '');
        formData.append('enable_filters', $('#wcps-showcase-form input[name="proddisp_enable_filters"]').is(':checked') ? 'yes' : '');
        formData.append('enable_pagination', $('#wcps-showcase-form input[name="proddisp_enable_pagination"]').is(':checked') ? 'yes' : '');
        
        // AJAX request to save showcase
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
            if (response.success) {
                // Show success message with auto-dismiss
                showAutoSaveMessage(response.data.message, 'success');
                
                // Reset button
                $('.wcps-save-showcase').prop('disabled', false).text(showcaseId ? 'Update Showcase' : 'Save Showcase');
                
                // Check if we're in edit mode
                var currentUrl = window.location.href;
                var isEditMode = currentUrl.includes('&edit=');
                
                // Only redirect for new showcases, not for editing
                if (!isEditMode && response.data.redirect) {
                    setTimeout(function() {
                        window.location.href = response.data.redirect;
                    }, 2000); // Redirect after 2 seconds
                }
                } else {
                    // Show error message
                    showAutoSaveMessage(response.data, 'error');
                    $('.wcps-save-showcase').prop('disabled', false).text(showcaseId ? 'Update Showcase' : 'Save Showcase');
                }
            },
            error: function() {
                // Show generic error message
                showAutoSaveMessage('Error saving showcase. Please try again.', 'error');
                $('.wcps-save-showcase').prop('disabled', false).text(showcaseId ? 'Update Showcase' : 'Save Showcase');
            }
        });
    }


    /**
     * Realtime preivew style update
     */
    // Add event listeners for design settings inputs
    $('#design input, #design select').on('change', function() {
        updatePreviewStyles();
    });

    // Function to update preview styles
    function updatePreviewStyles() {
        const previewContainer = $('#wcps-showcase-preview .wcps-container');
        if (!previewContainer.length) return;

        // Get all design settings values
        const styles = {
            // Container styles
            '--wcps-container-background': $('#proddisp_container_background').val() || '#ffffff3b',
            '--wcps-container-padding': $('#proddisp_container_padding').val() || '25px',
            '--wcps-container-margin': $('#proddisp_container_margin').val() || '0px',
            
            // Product styles
            '--wcps-background': $('#proddisp_background').val() || '#fff',
            '--wcps-product-content-padding': $('#proddisp_product_content_padding').val() || '15px',
            '--wcps-columns': $('#proddisp_columns').val() || '4',
            '--wcps-grid-gap': $('#proddisp_grid_gap').val() || '20px',
            '--wcps-grid-width': $('#proddisp_grid_width').val() || '100%',
            '--wcps-product-width': $('#proddisp_product_width').val() || '100%',
            '--wcps-product-flex-direction': $('#proddisp_product_flex').val() || 'column',
            '--wcps-product-background': $('#proddisp_product_background').val() || '#fff',
            
            // Border styles
            '--wcps-border-width': $('#proddisp_border_width').val() || '1',
            '--wcps-border-style': $('#proddisp_border_style').val() || 'solid',
            '--wcps-border-color': $('#proddisp_border_color').val() || '#eeeeee',
            '--wcps-border-radius': $('#proddisp_border_radius').val() || '4',
            '--wcps-box-shadow': $('#proddisp_box_shadow').val() || 'light',
            
            // Hover effects
            '--wcps-hover-transition': $('#proddisp_hover_transition').val() || '0.3',
            '--wcps-hover-effect': $('#proddisp_hover_effect').val() || 'lift',
            '--wcps-image-hover-effect': $('#proddisp_image_hover_effect').val() || 'zoom',
            
            // Image styles
            '--wcps-image-aspect-ratio': $('#proddisp_image_aspect_ratio').val() || '(1,1)',
            '--wcps-image-border-radius': $('#proddisp_image_border_radius').val() || '0',
            '--wcps-product-image-width': $('#proddisp_product_image_width').val() || '100%',
            '--wcps-product-image-height': $('#proddisp_product_image_height').val() || 'auto',
            
            // Badge styles
            '--wcps-product-badge-font-size': $('#proddisp_product_badge_font_size').val() || '12px',
            '--wcps-product-badge-font-weight': $('#proddisp_product_badge_font_weight').val() || 'normal',
            '--wcps-product-badge-text-transform': $('#proddisp_product_badge_text_transform').val() || 'none',
            '--wcps-product-badge-border-radius': $('#proddisp_product_badge_border_radius').val() || '20px',
            '--wcps-product-badge-padding': $('#proddisp_product_badge_padding').val() || '5px',
            '--wcps-product-badge-background': $('#proddisp_product_badge_background').val() || 'rgb(54, 182, 217)',
            '--wcps-product-badge-font-color': $('#proddisp_product_badge_font_color').val() || '#ffffff',
            
            // Button styles
            '--wcps-button-font-size': $('#proddisp_button_font_size').val() || '14px',
            '--wcps-button-inside-width': $('#proddisp_button_inside_width').val() || '100%',
            '--wcps-button-padding': $('#proddisp_button_padding').val() || '10px 20px',
            '--wcps-button-margin': $('#proddisp_button_margin').val() || '0',
            '--wcps-button-border': $('#proddisp_button_border').val() || 'none',
            '--wcps-button-hover-border': $('#proddisp_button_hover_border').val() || 'none',
            '--wcps-button-border-radius': $('#proddisp_button_border_radius').val() || '4',
            '--wcps-button-bg-color': $('#proddisp_button_bg_color').val() || '#0170B9',
            '--wcps-button-text-color': $('#proddisp_button_text_color').val() || '#ffffff',
            '--wcps-button-hover-bg': $('#proddisp_button_hover_bg').val() || '#015293',
            '--wcps-button-hover-text-color': $('#proddisp_button_hover_text_color').val() || '#ffffff',
            '--wcps-button-style': $('#proddisp_button_style').val() || 'default',
            '--wcps-button-animation': $('#proddisp_button_animation').val() || 'scale',
            
            // Content styles
            '--wcps-product-content-margin': $('#proddisp_product_content_margin').val() || '0',
            '--wcps-product-content-direction': $('#proddisp_product_content_direction').val() || 'column',
            '--wcps-product-content-background': $('#proddisp_product_content_background').val() || 'transparent',
            '--wcps-text-align': $('#proddisp_text_align').val() || 'left',
            
            // Typography styles
            '--wcps-product-title': $('#proddisp_product_title').val() || '#0170B9',
            '--wcps-product-title-hover-color': $('#proddisp_product_title_hover_color').val() || '#0170B9',
            '--wcps-title-size': $('#proddisp_title_size').val() || '16',
            '--wcps-title-weight': $('#proddisp_title_weight').val() || '600',
            '--wcps-price-font-color': $('#proddisp_price_color').val() || '#0170B9',
            '--wcps-price-delete-font-color': $('#proddisp_price_delete_color').val() || '#333333',
            '--wcps-price-font-size': $('#proddisp_price_size').val() || '18',
            '--wcps-price-font-weight': $('#proddisp_price_weight').val() || '700',
            '--wcps-desc-size': $('#proddisp_desc_size').val() || '14',
            '--wcps-description-color': $('#proddisp_description_color').val() || '#23282d',
            '--wcps-star-size': $('#proddisp_star_size').val() || '14px',
            '--wcps-star-color': $('#proddisp_star_color').val() || '#ffc107',
            
            // Display modes
            '--quickview-display-mode': $('#proddisp_quickview_display_mode').val() || 'icon_text',
            '--wishlist-displaymode': $('#proddisp_wishlist_display_mode').val() || 'icon_text',
            '--addtocart-display-mode': $('#proddisp_addtocart_display_mode').val() || 'icon_text',
            '--compare-display-mode': $('#proddisp_compare_display_mode').val() || 'icon_text'
        };

        // Update preview container styles
        Object.entries(styles).forEach(([property, value]) => {
            previewContainer.css(property, value);
        });

        // Log the changes for debugging
        console.log('Updated styles:', styles);
    }

    // Initialize preview styles on page load
    updatePreviewStyles();
    
    /**
     * Delete showcase via AJAX - FIXED
     */
    function deleteShowcase(showcaseId) {
        // Debug message to check if the function is being called
        console.log('Deleting showcase with ID:', showcaseId);
        
        // Get the nonce value - Important to get the correct nonce field
        var nonce = '';
        
        // Try to get nonce from the hidden input field
        if ($('#proddisp_nonce').length) {
            nonce = $('#proddisp_nonce').val();
        } else if ($('input[name="_wpnonce"]').length) {
            // If not found, try standard WordPress nonce field
            nonce = $('input[name="_wpnonce"]').val();
        }
        
        // Debug message to check if nonce is found
        console.log('Using nonce:', nonce);
        
        $.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
                action: 'proddisp_delete_showcase',
                id: showcaseId,
                nonce: nonce
            },
            success: function(response) {
                console.log('Delete response:', response);
                if (response.success) {
                    // Reload page to show updated list
                    window.location.reload();
                } else {
                    alert(response.data || 'Error deleting showcase.');
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', status, error);
                alert('Error deleting showcase. Please try again.');
            }
        });
    }


    // Icon picker -----------------------------------------------------------------------------STRAT
    // Icon Picker functionality
    
    function completeFontAwesomeIconPicker() {
        // Common FontAwesome 5 icons for e-commerce
        var commonIcons = [
            'fa-shopping-cart', 'fa-cart-plus', 'fa-cart-arrow-down', 'fa-heart', 'fa-heart-broken', 
            'fa-eye', 'fa-search', 'fa-search-plus', 'fa-chart-bar', 'fa-bars',
            'fa-exchange-alt', 'fa-sync-alt', 'fa-random', 'fa-th-large', 'fa-th-list',
            'fa-star', 'fa-info-circle', 'fa-question-circle', 'fa-plus', 'fa-minus',
            'fa-check', 'fa-times', 'fa-share-alt', 'fa-bookmark', 'fa-tag',
            'fa-link', 'fa-bell', 'fa-thumbs-up', 'fa-thumbs-down', 'fa-box',
            'fa-boxes', 'fa-truck', 'fa-credit-card', 'fa-money-bill', 'fa-percent',
            'fa-tags', 'fa-gift', 'fa-store', 'fa-layer-group', 'fa-cube'
        ];

        // Create and append the modal to body if it doesn't already exist
        if ($('#wcps-icon-modal').length === 0) {
            var modalHtml = '<div id="wcps-icon-modal" class="wcps-modal">' +
                '<div class="wcps-modal-content">' +
                '<span class="wcps-modal-close">&times;</span>' +
                '<h3>Select an Icon</h3>' +
                '<div class="wcps-icon-search">' +
                '<input type="text" placeholder="Search icons" class="wcps-icon-search-input">' +
                '</div>' +
                '<div class="wcps-icon-grid">';
            
            // Add icons to grid
            $.each(commonIcons, function(index, icon) {
                modalHtml += '<div class="wcps-icon-item" data-icon="' + icon + '">' +
                    '<i class="fas ' + icon + '"></i>' +
                    '<span class="wcps-icon-name">' + icon.replace('fa-', '') + '</span>' +
                    '</div>';
            });
            
            modalHtml += '</div></div></div>';
            
            $('body').append(modalHtml);
            
            // Style the modal with inline CSS if needed
            var modalStyles = '<style>' +
                '.wcps-modal { display: none; position: fixed; z-index: 9999; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); }' +
                '.wcps-modal-content { background-color: #fff; margin: 5% auto; padding: 20px; border-radius: 5px; width: 80%; max-width: 600px; max-height: 80vh; overflow-y: auto; }' +
                '.wcps-modal-close { float: right; cursor: pointer; font-size: 24px; }' +
                '.wcps-icon-search { margin-bottom: 15px; }' +
                '.wcps-icon-search-input { width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; }' +
                '.wcps-icon-grid { display: flex; flex-wrap: wrap; gap: 10px; }' +
                '.wcps-icon-item { display: flex; flex-direction: column; align-items: center; width: 80px; padding: 10px; border: 1px solid #eee; border-radius: 4px; cursor: pointer; transition: all 0.2s; }' +
                '.wcps-icon-item:hover { background-color: #f0f0f0; border-color: #ddd; }' +
                '.wcps-icon-item i { font-size: 24px; margin-bottom: 5px; }' +
                '.wcps-icon-name { font-size: 10px; text-align: center; word-break: break-word; }' +
                '</style>';
            
            $('head').append(modalStyles);
            
            // Handle icon item click
            $(document).on('click', '.wcps-icon-item', function() {
                var selectedIcon = $(this).data('icon');
                var $targetInput = $('#wcps-icon-modal').data('target');
                
                if ($targetInput) {
                    $targetInput.val(selectedIcon);
                    
                    // Update preview icon next to input if it exists
                    var $previewIcon = $targetInput.siblings('.wcps-icon-preview');
                    if ($previewIcon.length) {
                        $previewIcon.html('<i class="fas ' + selectedIcon + '"></i>');
                    } else {
                        // Add preview icon if it doesn't exist
                        $targetInput.after('<span class="wcps-icon-preview"><i class="fas ' + selectedIcon + '"></i></span>');
                    }
                }
                
                // Close the modal
                $('#wcps-icon-modal').hide();
            });
            
            // Close modal when clicking on X or outside the modal
            $(document).on('click', '.wcps-modal-close', function() {
                $('#wcps-icon-modal').hide();
            });
            
            $(document).on('click', function(e) {
                var $modal = $('#wcps-icon-modal');
                if ($modal.is(e.target)) {
                    $modal.hide();
                }
            });
            
            // Icon search functionality
            $(document).on('input', '.wcps-icon-search-input', function() {
                var searchTerm = $(this).val().toLowerCase();
                
                $('.wcps-icon-item').each(function() {
                    var iconName = $(this).data('icon').toLowerCase();
                    if (iconName.includes(searchTerm)) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            });
        }
        
        // Add icon picker buttons functionality
        $('.wcps-icon-select-btn').off('click').on('click', function(e) {
            e.preventDefault();
            
            var $input = $(this).siblings('.wcps-icon-input');
            
            // Set the target input for the modal
            $('#wcps-icon-modal').data('target', $input).show();
            
            // Pre-fill search with current value if it exists
            var currentIcon = $input.val().replace('fa-', '');
            $('.wcps-icon-search-input').val(currentIcon).trigger('input');
        });
        
        // Enhance the display of icon inputs
        $('.wcps-icon-input').each(function() {
            var $input = $(this);
            var iconValue = $input.val();
            
            // Add preview icon next to input if not already there
            if ($input.siblings('.wcps-icon-preview').length === 0) {
                $input.after('<span class="wcps-icon-preview"><i class="fas ' + iconValue + '"></i></span>');
            }
        });
    }

    // Call this function when document is ready and when initializing icon pickers
    function initFullIconFunctionality() {
        // Toggle display of icon picker based on checkbox state
        $('.wcps-tab-panel input[type="checkbox"]').each(function() {
            var $checkbox = $(this);
            var $iconSelect = $checkbox.closest('.wcps-button-option').find('.wcps-icon-select');
            
            // Set initial state
            if ($checkbox.is(':checked')) {
                $iconSelect.show();
            } else {
                $iconSelect.hide();
            }
            
            // Handle toggle
            $checkbox.off('change').on('change', function() {
                if ($(this).is(':checked')) {
                    $iconSelect.slideDown(200);
                } else {
                    $iconSelect.slideUp(200);
                }
            });
        });
        
        // Toggle icon picker based on display mode
        $('.wcps-tab-panel select[name$="_display_mode"]').each(function() {
            var $select = $(this);
            var $iconPicker = $select.closest('.wcps-icon-select').find('.wcps-icon-picker');
            
            // Set initial state
            if ($select.val() === 'text_only') {
                $iconPicker.hide();
            } else {
                $iconPicker.show();
            }
            
            // Handle change
            $select.off('change').on('change', function() {
                if ($(this).val() === 'text_only') {
                    $iconPicker.slideUp(200);
                } else {
                    $iconPicker.slideDown(200);
                }
            });
        });
        
        // Initialize FontAwesome icon picker
        completeFontAwesomeIconPicker();
    }

    // Add this line to your document.ready function
    $(document).ready(function() {
        // Rest of your existing code...
        
        // Initialize icon functionality
        initFullIconFunctionality();
        
        // For cases where content is loaded dynamically
        $(document).on('proddisp_content_loaded', function() {
            initFullIconFunctionality();
        });
    });
    // Icon picker -----------------------------------------------------------------------------END

    // Function to show copy success
    function showCopySuccess($button) {
        console.log('showCopySuccess called');
        
        var $icon = $button.find('.dashicons');
        console.log('Icon element found:', $icon.length);
        console.log('Icon before change:', $icon.attr('class'));
        
        // Store original icon classes
        var originalClasses = $icon.attr('class');
        console.log('Original classes stored:', originalClasses);
        
        // Add copied class to button
        $button.addClass('copied');
        
        // Change icon to checkmark
        $icon.attr('class', 'dashicons dashicons-yes');
        console.log('Icon after change to checkmark:', $icon.attr('class'));
        
        // Show success notice
        var $notice = $('<div class="wcps-copy-notice"><span class="dashicons dashicons-yes"></span>Shortcode copied to clipboard!</div>');
        $('body').append($notice);
        
        // Animate notice in
        setTimeout(function() {
            $notice.addClass('show');
        }, 10);
        
        // Remove copied class and notice after delay
        setTimeout(function() {
            console.log('Restoring icon...');
            $button.removeClass('copied');
            // Restore original icon classes
            $icon.attr('class', originalClasses);
            console.log('Icon after restoration:', $icon.attr('class'));
            $notice.removeClass('show');
            setTimeout(function() {
                $notice.remove();
            }, 300);
        }, 2000);
    }

    // --- Pricing Callback for ToastMaster Modal ---



    // Get start page js 
    // FAQ Toggle Functionality
    function initFAQ() {
        $('.faq-toggle').on('click', function(e) {
            e.preventDefault();
            
            const $toggle = $(this);
            const $content = $toggle.next('.faq-content');
            const $icon = $toggle.find('.faq-icon');
            const $faqItem = $toggle.closest('.faq-item');
            
            // Check if this FAQ is currently active
            const isActive = $toggle.hasClass('active');
            
            // Close all other FAQ items (accordion behavior)
            $('.faq-toggle').not($toggle).removeClass('active');
            $('.faq-content').not($content).slideUp(300);
            $('.faq-icon').not($icon).text('+').css('transform', 'rotate(0deg)');
            $('.faq-item').not($faqItem).removeClass('active');
            
            // Toggle current FAQ
            if (isActive) {
                // Close current FAQ
                $toggle.removeClass('active');
                $content.slideUp(300);
                $icon.text('+');
                $faqItem.removeClass('active');
            } else {
                // Open current FAQ
                $toggle.addClass('active');
                $content.slideDown(300);
                $icon.text('−');
                $faqItem.addClass('active');
            }
        });
    }

    // Smooth scroll to sections
    function initSmoothScroll() {
        $('a[href^="#"]').on('click', function(e) {
            const target = $(this.getAttribute('href'));
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 50
                }, 800, 'easeInOutCubic');
            }
        });
    }

    // Add entrance animations
    function initAnimations() {
        // Intersection Observer for fade-in animations
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                        observer.unobserve(entry.target);
                    }
                });
            }, {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            });

            // Observe elements for animation
            const animateElements = document.querySelectorAll('.stat-card, .faq-item, .support-card, .step-item, .shortcode-item');
            animateElements.forEach(el => {
                el.classList.add('animate-element');
                observer.observe(el);
            });
        }
    }

    // Copy shortcode functionality
    function initCopyShortcodes() {
        // Add copy buttons to code blocks
        $('.code-block code').each(function() {
            const $code = $(this);
            const $codeBlock = $code.parent();
            
            // Create copy button
            const $copyBtn = $('<button>', {
                class: 'copy-shortcode-btn',
                html: '<span class="copy-icon">📋</span>',
                title: 'Copy shortcode'
            });
            
            // Position button
            $codeBlock.css('position', 'relative');
            $copyBtn.css({
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: 'rgba(0,0,0,0.1)',
                border: 'none',
                padding: '5px 8px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px',
                transition: 'all 0.3s ease'
            });
            
            $codeBlock.append($copyBtn);
            
            // Copy functionality
            $copyBtn.on('click', function(e) {
                e.preventDefault();
                
                const shortcode = $code.text();
                
                // Modern clipboard API
                if (navigator.clipboard && window.isSecureContext) {
                    navigator.clipboard.writeText(shortcode).then(() => {
                        showCopySuccess($copyBtn);
                    }).catch(() => {
                        fallbackCopy(shortcode, $copyBtn);
                    });
                } else {
                    fallbackCopy(shortcode, $copyBtn);
                }
            });
        });
    }

    // Show copy success feedback
    function showCopySuccess($btn) {
        const originalHTML = $btn.html();
        $btn.html('<span class="copy-icon">✅</span>')
            .css('background', 'rgba(40, 167, 69, 0.2)');
        
        setTimeout(() => {
            $btn.html(originalHTML)
                .css('background', 'rgba(0,0,0,0.1)');
        }, 2000);
        
        // Show toast notification
        showToast('Shortcode copied to clipboard!', 'success');
    }

    // Fallback copy method for older browsers
    function fallbackCopy(text, $btn) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.setAttribute('readonly', '');
        textArea.style.position = 'absolute';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        
        textArea.select();
        textArea.setSelectionRange(0, 99999); // For mobile devices
        
        try {
            const successful = document.execCommand('copy');
            if (successful) {
                showCopySuccess($btn);
            } else {
                showToast('Failed to copy shortcode', 'error');
            }
        } catch (err) {
            showToast('Copy not supported', 'error');
        }
        
        document.body.removeChild(textArea);
    }

    // Toast notification system
    function showToast(message, type = 'info') {
        // Remove existing toast
        $('.wcps-toast').remove();
        
        const $toast = $('<div>', {
            class: `wcps-toast wcps-toast-${type}`,
            html: message
        });
        
        // Toast styles
        $toast.css({
            position: 'fixed',
            top: '20px',
            right: '20px',
            background: type === 'success' ? '#28a745' : (type === 'error' ? '#dc3545' : '#007cba'),
            color: 'white',
            padding: '12px 20px',
            borderRadius: '6px',
            fontSize: '14px',
            fontWeight: '500',
            zIndex: 999999,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            transform: 'translateX(100%)',
            transition: 'transform 0.3s ease'
        });
        
        $('body').append($toast);
        
        // Animate in
        setTimeout(() => {
            $toast.css('transform', 'translateX(0)');
        }, 100);
        
        // Auto remove
        setTimeout(() => {
            $toast.css('transform', 'translateX(100%)');
            setTimeout(() => {
                $toast.remove();
            }, 300);
        }, 3000);
    }

    // Add hover effects to cards
    function initCardEffects() {
        $('.stat-card, .support-card, .step-item').hover(
            function() {
                $(this).addClass('card-hover');
            },
            function() {
                $(this).removeClass('card-hover');
            }
        );
    }

    // Parallax effect for welcome section
    function initParallax() {
        if ($(window).width() > 768) {
            $(window).on('scroll', function() {
                const scrolled = $(window).scrollTop();
                const rate = scrolled * -0.5;
                
                $('.wcps-welcome-section::before').css({
                    transform: `translateY(${rate}px)`
                });
            });
        }
    }

    // Loading animation for stats
    function animateStats() {
        $('.stat-number').each(function() {
            const $this = $(this);
            const countTo = $this.text();
            
            if (!isNaN(countTo)) {
                $this.text('0');
                
                $({ countNum: 0 }).animate({
                    countNum: countTo
                }, {
                    duration: 2000,
                    easing: 'easeOutCubic',
                    step: function() {
                        $this.text(Math.floor(this.countNum));
                    },
                    complete: function() {
                        $this.text(countTo);
                    }
                });
            }
        });
    }

    // Progress bar animations
    function initProgressBars() {
        $('.progress-bar').each(function() {
            const $bar = $(this);
            const percentage = $bar.data('percentage') || 0;
            
            // Initialize with 0 width
            $bar.css('width', '0%');
            
            // Animate to target percentage when visible
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        $bar.animate({ width: percentage + '%' }, 1500, 'easeOutCubic');
                        observer.unobserve(entry.target);
                    }
                });
            });
            
            observer.observe($bar[0]);
        });
    }

    // Typewriter effect for titles
    function initTypewriter() {
        $('.typewriter-text').each(function() {
            const $element = $(this);
            const text = $element.text();
            const speed = $element.data('speed') || 50;
            
            $element.text('');
            
            let i = 0;
            const typeWriter = () => {
                if (i < text.length) {
                    $element.text($element.text() + text.charAt(i));
                    i++;
                    setTimeout(typeWriter, speed);
                }
            };
            
            // Start typing when element is visible
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setTimeout(typeWriter, 500);
                        observer.unobserve(entry.target);
                    }
                });
            });
            
            observer.observe($element[0]);
        });
    }

    // Enhanced card interactions
    function initEnhancedCards() {
        $('.support-card, .step-item, .shortcode-item').each(function() {
            const $card = $(this);
            
            $card.on('mouseenter', function() {
                $card.addClass('card-elevated');
                // Add ripple effect
                const ripple = $('<div class="card-ripple"></div>');
                $card.append(ripple);
                
                setTimeout(() => {
                    ripple.remove();
                }, 600);
            }).on('mouseleave', function() {
                $card.removeClass('card-elevated');
            });
        });
    }

    // Scroll-triggered animations
    function initScrollAnimations() {
        const elements = $('.animate-on-scroll');
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const $el = $(entry.target);
                    const animationType = $el.data('animation') || 'fadeInUp';
                    const delay = $el.data('delay') || 0;
                    
                    setTimeout(() => {
                        $el.addClass(`animated ${animationType}`);
                    }, delay);
                    
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        
        elements.each(function() {
            observer.observe(this);
        });
    }

    // Auto-resize textarea
    function initAutoResize() {
        $('textarea.auto-resize').on('input', function() {
            this.style.height = 'auto';
            this.style.height = (this.scrollHeight) + 'px';
        });
    }

    // Keyboard navigation for FAQ
    function initKeyboardNavigation() {
        $('.faq-toggle').on('keydown', function(e) {
            const $current = $(this);
            const $items = $('.faq-toggle');
            const currentIndex = $items.index($current);
            
            switch(e.keyCode) {
                case 38: // Up arrow
                    e.preventDefault();
                    if (currentIndex > 0) {
                        $items.eq(currentIndex - 1).focus();
                    }
                    break;
                case 40: // Down arrow
                    e.preventDefault();
                    if (currentIndex < $items.length - 1) {
                        $items.eq(currentIndex + 1).focus();
                    }
                    break;
                case 13: // Enter
                case 32: // Space
                    e.preventDefault();
                    $current.click();
                    break;
            }
        });
    }

    // Loading states for buttons
    function initButtonLoading() {
        $('.btn-with-loading').on('click', function() {
            const $btn = $(this);
            const originalText = $btn.html();
            
            $btn.prop('disabled', true)
                .html('<span class="loading-spinner"></span> Loading...');
            
            // Simulate loading (remove this in production)
            setTimeout(() => {
                $btn.prop('disabled', false).html(originalText);
            }, 2000);
        });
    }

    // Search functionality for FAQs
    function initFAQSearch() {
        const $searchInput = $('#faq-search');
        if ($searchInput.length) {
            $searchInput.on('input', function() {
                const searchTerm = $(this).val().toLowerCase();
                
                $('.faq-item').each(function() {
                    const $item = $(this);
                    const text = $item.find('.faq-toggle span').first().text().toLowerCase() + 
                                $item.find('.faq-content').text().toLowerCase();
                    
                    if (text.includes(searchTerm)) {
                        $item.show();
                    } else {
                        $item.hide();
                    }
                });
                
                // Show "no results" message if needed
                const visibleItems = $('.faq-item:visible').length;
                if (visibleItems === 0 && searchTerm !== '') {
                    if (!$('.no-results-message').length) {
                        $('.faq-container').append('<div class="no-results-message">No FAQs found matching your search.</div>');
                    }
                } else {
                    $('.no-results-message').remove();
                }
            });
        }
    }

    // Initialize all functionality
    function init() {
        initFAQ();
        initSmoothScroll();
        initAnimations();
        initCopyShortcodes();
        initCardEffects();
        initParallax();
        initProgressBars();
        initTypewriter();
        initEnhancedCards();
        initScrollAnimations();
        initAutoResize();
        initKeyboardNavigation();
        initButtonLoading();
        initFAQSearch();
        
        // Animate stats when page loads
        setTimeout(animateStats, 500);
        
        // Add loaded class to enable CSS transitions
        $('body').addClass('page-loaded');
    }

    // Initialize when document is ready
    init();

    // Re-initialize on window resize for responsive adjustments
    $(window).on('resize', function() {
        // Only re-init parallax on resize
        initParallax();
    });

    // Add custom easing functions
    $.easing.easeOutCubic = function(x, t, b, c, d) {
        return c*((t=t/d-1)*t*t + 1) + b;
    };

    $.easing.easeInOutCubic = function(x, t, b, c, d) {
        if ((t/=d/2) < 1) return c/2*t*t*t + b;
        return c/2*((t-=2)*t*t + 2) + b;
    };

    // Utility functions
    const utils = {
        // Debounce function
        debounce: function(func, wait, immediate) {
            let timeout;
            return function() {
                const context = this, args = arguments;
                const later = function() {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                const callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },
        
        // Throttle function
        throttle: function(func, limit) {
            let inThrottle;
            return function() {
                const args = arguments;
                const context = this;
                if (!inThrottle) {
                    func.apply(context, args);
                    inThrottle = true;
                    setTimeout(() => inThrottle = false, limit);
                }
            };
        },
        
        // Generate random ID
        generateId: function() {
            return Math.random().toString(36).substr(2, 9);
        },
        
        // Format number with commas
        formatNumber: function(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    };

    // Make utils available globally
    window.WCPSUtils = utils;
    

})(jQuery);
